<template>
    <div>
        <div class="menu" :class="{'minimized': sidePanel.minimized, 'details': sidePanel.details}">
            <ul :class="{'hide-details': !sidePanel.details}">
                <li class="sub-header">
                    Conference
                </li>
                <router-link :to="{name: 'conf-information'}" custom v-slot="{ navigate, isActive }" active-class="active">

                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip :label="page.conferenceInformation.label" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-circle-info"></i>
                        </b-tooltip><span class="nav-title">{{ page.conferenceInformation.label }}</span>
                        <div class="meta">{{ page.conferenceInformation.meta }}</div>
                    </li>
                </router-link>
                <router-link :to="{name: 'schedule'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip :label="page.sessionsSchedule.label" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-calendar-circle-user"></i>
                        </b-tooltip><span class="nav-title">{{ page.sessionsSchedule.label }}</span>
                        <div class="meta">{{ page.sessionsSchedule.meta }}</div>
                    </li>
                </router-link>
                <router-link :to="{name: 'on-demand'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip :label="page.onDemandContent.label" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-clapperboard-play"></i>
                        </b-tooltip><span class="nav-title">{{ page.onDemandContent.label }}</span>
                        <div class="meta">{{ page.onDemandContent.meta }}</div>
                    </li>
                </router-link>


                <li class="sub-header">
                    Registration & Records
                </li>

                <router-link :to="{name: 'record-log'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip :label="page.recordAttendance.label" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-clipboard-list-check"></i>
                        </b-tooltip><span class="nav-title">{{ page.recordAttendance.label }}</span>
                        <div class="meta">{{ page.recordAttendance.meta }}</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'conf-applications'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip :label="page.conferenceCertificationsForms.label" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-file-certificate"></i>
                        </b-tooltip><span class="nav-title">{{ page.conferenceCertificationsForms.label }}</span>
                        <div class="meta">{{ page.conferenceCertificationsForms.meta }}</div>
                        <div class="meta mt-3" v-if="registration.isIncompleteApps"><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Action is Required</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'registration'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip :label="page.yourRegistration.label" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-id-badge"></i>
                        </b-tooltip><span class="nav-title">{{ page.yourRegistration.label }}</span>
                        <div class="meta">{{ page.yourRegistration.meta }}</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'po-request'}" custom v-slot="{ navigate, isActive }" active-class="active" v-if="registration.is_po_pending">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip :label="page.purchaseOrder.label" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-file-invoice"></i>
                        </b-tooltip><span class="nav-title">{{ page.purchaseOrder.label }}</span>
                        <div class="meta">{{ page.purchaseOrder.meta }}</div>
                        <div class="meta mt-3"><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Action is Required</div>
                    </li>
                </router-link>

            </ul>
        </div>
        <div class="controls ">
            <div class="columns is-gapless">
                <div class="column has-text-right">
                    <span @click="toggleDetails()" v-if="!sidePanel.minimized"><i class="fad mt-2 mr-3" :class="{'fa-bars': sidePanel.details, 'fa-diagram-cells': !sidePanel.details}"></i></span>
                    <span @click="minimize(false)" v-if="sidePanel.minimized"><i class="fad fa-chevrons-right mt-2"></i></span>
                    <span @click="minimize(true)" v-else><i class="fad fa-chevrons-left mt-2"></i></span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {SITE_PAGES} from "../../constants/siteMap";
    import pkg from '../../../package.json';
    import moment from "moment";

    // Menu labels and descriptions come from the site map (constants/siteMap),
    // which is also published for the support AI drafter
    export default {
        name: "ConfSideNav",
        data: function() {
            return {
                details: true,
                version: pkg.version
            };
        },
        computed: {
            page: () => SITE_PAGES,
            ...mapGetters(['currentUser', 'sidePanel', 'registration']),
            incompleteApps: function() {
                // if (this.registration && this.registration.applications) {
                //     if (this.registration.applications.length === 0) return false;
                //     return this.registration.applications.filter(app => !app.completed_at).length > 0;
                // } else {
                //     return false;
                // }

                // for (let confApp of this.registration.conference.applications) {
                //     let enrollApplication = this.registration.applications.find((enrollApp) => {
                //         return enrollApp.conf_application_id === confApp.id;
                //     });
                //     if (moment(this.registration.conference.start_at).isBefore(moment()) && this.registration.reg_record_log.length > 0 && !enrollApplication || (enrollApplication && !enrollApplication.completed_at)) {
                //         return true;
                //     }
                // }
                return false;
            }
        },
        methods: {
            toggleDetails: function() {
                this.$store.commit('setDetails', !this.sidePanel.details);
            },
            minimize: function(state) {
                this.$store.commit('setMinimized', state);
            }
        },
        mounted() {
            let width = window.innerWidth;
            if (width < 768) {
                this.$store.commit('setMinimized', true);
                // this.$store.commit('setDetails', false);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/sidemenu";
</style>
